export default __webpack_public_path__ + "static/Transparent-028efb3a880f13b931fdbbeb7a4adaeb.svg";